export const isDefaultHeatmap = (heatmap) =>
  heatmap?.type === 'system' &&
  heatmap?.name?.trim().toLowerCase() === 'default heatmap'

export const getVisibleHeatmaps = (heatmaps) => {
  if (!Array.isArray(heatmaps)) return []

  const hasUserHeatmaps = heatmaps.some((heatmap) => heatmap.type === 'user')

  return hasUserHeatmaps
    ? heatmaps.filter((heatmap) => !isDefaultHeatmap(heatmap))
    : heatmaps
}

export const getPreferredHeatmapId = (heatmaps, currentMapId = '') => {
  const visibleHeatmaps = getVisibleHeatmaps(heatmaps)

  if (visibleHeatmaps.some((heatmap) => heatmap.id === currentMapId)) {
    return currentMapId
  }

  const userHeatmaps = visibleHeatmaps.filter(
    (heatmap) => heatmap.type === 'user'
  )
  const preferredUserHeatmap =
    userHeatmaps.find((heatmap) => heatmap.pin) || userHeatmaps[0]

  if (preferredUserHeatmap) return preferredUserHeatmap.id

  return (
    visibleHeatmaps.find(isDefaultHeatmap)?.id ||
    visibleHeatmaps[0]?.id ||
    ''
  )
}
